import * as React from 'react'
import {
  TablePagination,
  useTablePagination,
  LeadIcon,
} from '@sales-center/components'
import { tableStyles } from './useTableStyles'
import { useGetLocationLeadsByPage } from '@user/store/leadSummary/useGetLocationLeadsByPage'
import format from 'date-fns/format'
import { toast } from '@sales-center/components'
import { EmptyRows } from './EmptyRows'
import { currencyString } from '@sales-center/common'
import Table from '@mui/material/Table'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import TableBody from '@mui/material/TableBody'
import TableFooter from '@mui/material/TableFooter'
import LinearProgress from '@mui/material/LinearProgress'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'

interface Props {
  externalLinkId: string
  perPage?: number
}

export const LeadSummaryTable: React.FC<Props> = ({
  externalLinkId,
  perPage = 5,
}) => {
  const { page, onChangePage } = useTablePagination()

  const {
    status,
    result: { count, items },
  } = useGetLocationLeadsByPage(externalLinkId, page + 1, perPage)

  const emptyRows = count > items.length ? perPage - items.length : 0
  const theme = useTheme()
  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell sx={tableStyles.header}>
            <LeadIcon width={42} height={42} theme={theme} />
          </TableCell>
          <TableCell sx={tableStyles.header}>Date Created</TableCell>
          <TableCell sx={tableStyles.header}>Primary Contact</TableCell>
          <TableCell sx={tableStyles.header}>Owner</TableCell>
          <TableCell sx={tableStyles.header}>Value</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {items.map((i) => (
          <TableRow key={i.id}>
            <TableCell sx={tableStyles.manageLink}>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault()
                  toast.error('not implemented')
                }}
              >
                Manage
              </a>
            </TableCell>
            <TableCell>
              {i.createdDate !== null ? format(i.createdDate, 'MM/dd/yy') : '-'}
            </TableCell>
            <TableCell>{i.primaryContact || ''}</TableCell>
            <TableCell>{i.owner === null ? 'Unassigned' : i.owner}</TableCell>
            <TableCell>{`$${currencyString(i.value)}`}</TableCell>
          </TableRow>
        ))}
        <EmptyRows rows={emptyRows} columns={4} />
      </TableBody>
      <TableFooter>
        <TableRow>
          <TableCell colSpan={4} sx={tableStyles.footerCell}>
            <Box sx={tableStyles.footerContainer}>
              {status === 'pending' && (
                <LinearProgress color="primary" sx={tableStyles.loading} />
              )}
              {count > perPage && (
                <TablePagination
                  sx={tableStyles.pagination}
                  page={page}
                  perPage={perPage}
                  resultCount={count}
                  onChange={onChangePage}
                  disabled={status === 'pending'}
                />
              )}
            </Box>
          </TableCell>
        </TableRow>
      </TableFooter>
    </Table>
  )
}
LeadSummaryTable.displayName = 'LeadSummaryTable'
